import { useRef } from 'react'

import {
  type ContactFormState,
  useInitContactFormState,
} from '../../contact-form'
import { useApiOrdersSwrGetOrders } from '../../order'
import { useDirectFormDialogContext } from '../components/DirectContactFormDialog/DirectContactFormDialogContext'

export const useDirectContactFormFormStateInitialization =
  (): ContactFormState => {
    const { product, subject } = useDirectFormDialogContext()

    const { data } = useApiOrdersSwrGetOrders()

    const initProduct =
      data?.orders && data.orders.length > 0
        ? { name: '', upid: '' }
        : undefined

    const initSubOrderNumber =
      data?.orders && data.orders.length > 0 ? '' : undefined

    // If a user (not logged in) on the Contact Form selects a subject option
    // that requires the user to be logged in, then logs in, after login,
    // the formState is forced to re-initialize and
    // as a result some of the initialization values get lost.
    // The consequence of this is that a user cannot submit the form after the login.
    // To allow form submission after the login,
    // I used useRef to maintain the initial initialization state of formState even after the re-initialization
    const formStateRef = useRef(
      useInitContactFormState({
        formSubject: subject,
        product: product ?? initProduct,
        subOrderNumber: initSubOrderNumber,
      }).formState,
    )

    return formStateRef.current
  }
